<template>
  <stock-map-mapbox
    v-if="!googleMode"
    :sourceProgramsMap="sourceProgramsMap"
    :filters="filters"
    :mapLoading="mapLoading"
    :getProgramsLoading="getProgramsLoading"
  ></stock-map-mapbox>
  <stock-map-google
    v-else
    :sourceProgramsMap="sourceProgramsMap"
    :filters="filters"
    :mapLoading="mapLoading"
    :getProgramsLoading="getProgramsLoading"
  ></stock-map-google>
</template>

<script>
  import StockMapMapbox from './StockMapMapbox'
  import StockMapGoogle from './StockMapGoogle'

  export default {
    name: 'StockMap',
    components: {
      StockMapMapbox,
      StockMapGoogle
    },
    computed: {
      googleMode () {
        return this.$configs.COUNTRY !== 'FRA'
      },
      loading () {
        return this.mapLoading
      }
    },
    props: {
      sourceProgramsMap: {
        type: Object
      },
      filters: {
        type: Object
      },
      mapLoading: {
        type: Boolean
      },
      getProgramsLoading: {
        type: Boolean
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/stock/StockMap.vue